import { useState, useEffect } from 'react';
//REMOVE IN LIVE APP, THIS JUST SHOWS VIEWPORT DIMENSIONS FOR TESTING

const ViewportTracker = () => {
  const [dimensions, setDimensions] = useState({ 
    width: window.innerWidth, 
    height: window.innerHeight 
  });

  useEffect(() => {
    const handleResize = () => {
      setDimensions({
        width: window.innerWidth,
        height: window.innerHeight
      });
    };

    window.onresize = handleResize;
    return () => window.onresize = null; // Cleanup
  }, []);

  // THE SWITCH: Move the check here, after the hooks
  if (!window.MY_SWITCH.isDev) {
    return null; // Renders absolutely nothing in Production
  }
  return (
    <div style={{
      position: 'fixed',
      bottom: '10px',
      right: '10px',
      backgroundColor: 'rgba(0,0,0,0.7)',
      color: 'white',
      padding: '5px 10px',
      borderRadius: '5px',
      fontSize: '12px',
      zIndex: 9999,
      fontFamily: 'monospace',
      pointerEvents: 'none' 
    }}>
      {dimensions.width}px × {dimensions.height}px
    </div>
  );
};

export default ViewportTracker;